exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_wks-ext.js
// module id = 70
// module chunks = 21